import React from 'react';
import PropTypes from 'prop-types';
import { Notification, Typography } from '@telus-uds/components-web';
import RichText from '../richText';

const ErrorMessage = ({
  type = 'text',
  text = '',
  data,
  options = { renderMark: {}, renderNode: {} },
  isError
}) => {
  return (
    isError && (
      <div style={{ margin: '1em 0', width: '100%' }}>
        <Notification variant={{ validation: 'error' }} copy="en">
          {type === 'richText' ? (
            <RichText data={data} options={options} />
          ) : (
            <Typography variant={{ bold: true }}>{text}</Typography>
          )}
        </Notification>
      </div>
    )
  );
};

ErrorMessage.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  data: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  options: PropTypes.shape({
    renderMark: PropTypes.object,
    renderNode: PropTypes.object
  }),
  isError: PropTypes.bool
};

export default ErrorMessage;
